import * as React from 'react'
import { TransferStatus, InvoiceStatus } from '@getgreenline/homi-shared'

interface Props {
  status: TransferStatus | InvoiceStatus
}

export function getStatusObject(status: TransferStatus | InvoiceStatus): {
  className: string
  text: string
  icon: string
} {
  switch (status) {
    case 'pending':
      return {
        className: 'pending',
        text: 'Pending',
        icon: 'clock-o',
      }
    case 'inProgress':
      return {
        className: 'confirmed',
        text: 'In progress',
        icon: 'file-o',
      }
    case 'completed':
      return {
        className: 'completed',
        text: 'Completed',
        icon: 'check',
      }
    case 'cancelled':
      return {
        className: 'cancelled',
        text: 'Cancelled',
        icon: 'ban',
      }
    default:
      return {
        className: 'badge-secondary',
        text: status,
        icon: '',
      }
  }
}

export class StatusBadge extends React.Component<Props, {}> {
  render() {
    const statusObject = getStatusObject(this.props.status)

    return (
      <div className={`status-badge ${statusObject.className}`}>
        <span>{statusObject.text}</span>
      </div>
    )
  }
}
